import { autoScaleFont } from "@core/Utils/HelperFunction"
import { Constants } from "../Utils/Constants"

export class Chip extends Phaser.GameObjects.Container {
	public text: Phaser.GameObjects.BitmapText

	private chipSprite: Phaser.GameObjects.Image

	VelocityX: number = 0
	VelocityY: number = 0

	constructor(scene: Phaser.Scene, private atlas: string, tex: string, x: number, y: number, width: number, height: number, value: string, origin?: [number, number]) {
		super(scene, x, y)

		this.width = width
		this.height = height

		this.chipSprite = new Phaser.GameObjects.Image(scene, 0, 0, atlas, tex)
		this.chipSprite.setOrigin(0.5)
		this.chipSprite.displayWidth = width
		this.chipSprite.displayHeight = height
		this.chipSprite.width = width
		this.chipSprite.height = height
		this.add(this.chipSprite)

		this.text = new Phaser.GameObjects.BitmapText(scene, 0, 0, 'bodonistd-bold', value);
		this.text.tint = 0x000000;
		this.text[Constants.CHIP.FONT_NAME] = Constants.CHIP.FONT_SIZE;
		this.text.setData(Constants.CHIP.FONT_NAME, Constants.CHIP.FONT_SIZE);
		this.text.getData(Constants.CHIP.FONT_NAME);
		this.text.setFontSize(this.text[Constants.CHIP.FONT_NAME]);
		this.text.setOrigin(0.5);
		if (origin)
			this.text.setOrigin(...origin);
		this.add(this.text);
		this.Text = value;
	}

	set Text(text: string) {
		if (text == this.text.text) return;
		this.text.text = text;
		if (text.length < 2)
			autoScaleFont(this.text, this.chipSprite.displayWidth * 0.8, this.chipSprite.height);
		else
			autoScaleFont(this.text, this.chipSprite.displayWidth * 1.1, this.chipSprite.height);
	}

	ChangeTexture(texture: string): void {
		this.chipSprite.setTexture(this.atlas, texture);
	}

}
